import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import 'jquery-confirm';

export default function Redemptions(props) {
    if (!props.penalistData.hasOwnProperty('data') || props.penalistData.data === null) return <></>;
    const { redemption, rewards } = props.penalistData.data;
    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Redemptions</h4>
                </div>
            </CardHeader>
            <CardBody>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Total Earned : <br />{rewards.totalPoints}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Completed Redeemed :  <br />{redemption.totalRedeemed}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Pending Redemptions:  <br />{redemption.totalPendingRedeemed}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Total Available Points : <br />{rewards.totalLeftPoints}
                        </Paper>
                    </Grid>
                </Grid>
            </CardBody>
        </Card>
    )
}